<template>
  <div class="navigation-bar">
    <div class="menu" @click="navItemsVisibility">
      <i class="n-i n-i-menu-a"></i>
    </div>
    <div class="navigation-items"
         v-if="navigationItems"
         v-click-outside-element="panelsElementConfig">
      <div v-for="(item, index) in toolbarItems"
           :key="index">
        <div v-if="item.route === 'tickets'" @click="expandFilter(index)">
          <a  :class="item.class" >
          {{item.text}}
          <i class="n-i n-i-arrow-down-b"></i>
          </a>
        </div>
        <div ref="date-picker"></div>
        <DateRangePicker v-if="index === 'date'"
                         v-show="toolbarItems[index].status"
                         @datePicker="loadPage">
        </DateRangePicker>
        <SingleSelectFilter v-if="index === 'channels'"
                            v-show="toolbarItems[index].status"
                            :id="'id'"
                            :filter="currentChannel"
                            :filterDelay="2000"
                            :items="channels"
                            :title="'text'"
                            @inputFilter="setChannelItem">
        </SingleSelectFilter>
        <MultiSelectFilter :id="item.id"
                           :items="filters"
                           :filter="index"
                           :filters="item.filters"
                           :filtersNumber="filtersNumber"
                           :search='item.search'
                           :searchDelay="200"
                           :selectDelay="2000"
                           :selected="item.selected"
                           :status="item.status"
                           :title="item.title"
                           @input="setToolbarItem"
                           @search="searchFilters">
        </MultiSelectFilter>
      </div>
    </div>
    <div class="navigation-filters">
      <div class="search-text" >
        <input type="text"
               v-model="searchItems"
               @input="searchData">
        <div class="placeholder" v-if="!searchItems">
          <span>
            <localized-label>fieldSearchLabel</localized-label>
          </span>
        </div>
      </div>
      <div v-click-outside-element="exportElementConfig"
           v-if="ticketsRoute"
           class="export"
           :class="disabledClass"
           @click="expandExportFilter()">
        <i class="n-i n-i-download"></i>
      </div>
      <!-- Removed from production because it led to database overload -->
      <!-- <div v-click-outside-element="refreshElementConfig"
        class="refresh" @click="expandRefreshFilter()">
        <i class="n-i n-i-refresh-a"></i>
      </div> -->
       <div v-click-outside-element="restartElementConfig"
        class="restart" @click="expandRestartFilters()">
        <i class="n-i n-i-filter-c"></i>
      </div>
      <div class="export-container"
           ref="export"
           v-show="exportFilter">
        <div class="export-text">
          <div><localized-label>exportLabel</localized-label></div>
        </div>
        <div class="export-item"
             v-for="(item, index) in exportItems"
            :key="index"
            @click="downloadFile(item.type)">
            {{item.text}}
        </div>
      </div>
      <div class="refresh-container"
           ref="refresh"
           v-show="refreshFilter">
        <div class="refresh-text">
          <span>
            <localized-label>refreshSetGridLabel</localized-label>
          </span>
        </div>
        <div>
          <SingleSelectFilter :id="'interval'"
                              :filter="currentRefreshItem"
                              :filterDelay="500"
                              :items="refreshRadioButtonsItems"
                              :title="'text'"
                              @inputFilter="setRefreshItem">
          </SingleSelectFilter>
        </div>
      </div>
      <div class="restart-container"
           ref="restart"
           v-show="restartFilter">
        <div><localized-label>filtersLabel</localized-label></div>
        <div>
          <button @click="resetHeaderFilters">
             <localized-label>resetFiltersLabel</localized-label>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  assign,
  cloneDeep,
  debounce,
  each,
  filter,
  get,
  has,
  includes,
  isEmpty,
  toLower,
} from 'lodash';
import { mapGetters, mapActions } from 'vuex';
import { bus } from '../utility';
import { momentable, paginable } from '../mixins';
import DateRangePicker from './DateRangePicker';
import SingleSelectFilter from './SingleSelectFilter';
import MultiSelectFilter from './MultiSelectFilter';
import ClickOutsideElement from '../directives/outside-element';


export default {
  name: 'Header',
  components: {
    DateRangePicker,
    SingleSelectFilter,
    MultiSelectFilter,
  },
  directives: {
    ClickOutsideElement,
  },
  mixins: [
    momentable,
    paginable,
  ],
  data() {
    const locale = this.$store.getters.translations;
    return {
      toolbarItems: null,
      exportItems: [
        { text: 'CSV', type: 'csv' },
      ],
      refreshRadioButtonsItems: [
        { text: locale.refreshNoRefreshLabel, interval: 0 },
        { text: locale.refreshFiveSecondsLabel, interval: 5000 },
        { text: locale.refreshTenSecondsLabel, interval: 10000 },
        { text: locale.refreshtThirtySecondsLabel, interval: 30000 },
        { text: locale.refreshSixtySecondsLabel, interval: 60000 },
        { text: locale.refreshFiveMinutesLabel, interval: 300000 },
      ],
      panelsElementConfig: {
        exclude: [
          'date-picker',
        ],
        handler: 'closeFilter',
      },
      exportElementConfig: {
        exclude: ['export'],
        handler: 'closeExportFilter',
      },
      refreshElementConfig: {
        exclude: ['refresh'],
        handler: 'closeRefreshFilter',
      },
      restartElementConfig: {
        exclude: ['restart'],
        handler: 'closeRestartFilter',
      },
      currentChannel: null,
      currentRefreshItem: 0,
      currentFilter: null,
      filtersNumber: 10,
      exportFilter: false,
      navigationItems: true,
      refreshInterval: null,
      refreshFilter: false,
      refreshTimer: null,
      restartFilter: false,
      searchFilter: null,
      searchItems: null,
    };
  },
  computed: {
    ...mapGetters([
      'channel',
      'channels',
      'route',
      'ticketFilters',
      'tickets',
      'toolbarFilters',
      'translation',
      'translations',
    ]),
    filters() {
      const items = cloneDeep(this.ticketFilters);
      if (this.searchFilter && !isEmpty(this.searchFilter.search)) {
        items[this.searchFilter.filter] = filter(this.ticketFilters[this.searchFilter.filter],
          item => includes(item[this.searchFilter.title], this.searchFilter.search));
      }

      return items;
    },
    mainToolbarItems() {
      const items = {
        date: {
          text: this.translation('toolbarDateLabel'), class: 'text-color', status: false, route: 'tickets',
        },
      };
      if (this.ticketsRoute) {
        const channels = {
          text: this.translation('toolbarChannelLabel'), class: 'text-color', status: false, route: 'tickets',
        };
        assign(items, { channels });
      }

      return items;
    },
    disabledClass() {
      return !this.tickets.length ? 'filterDisabled' : false;
    },
    ticketsRoute() {
      return this.route.name === 'Tickets';
    },
  },
  watch: {
    channels(value) {
      if (value.length) {
        this.currentChannel = this.channel;
      }
    },
    toolbarFilters(update) {
      this.toolbarItems = cloneDeep(this.mainToolbarItems);
      if (this.ticketsRoute) {
        const filters = this.toolbarItems;
        each(update, (item, index) => {
          filters[index] = item;
        });
        this.toolbarItems = cloneDeep(filters);
      }
    },
  },
  created() {
    this.currentChannel = this.channel;
    this.toolbarItems = this.mainToolbarItems;
    if (has(this.toolbarItems, 'channels')) {
      this.toolbarItems.channels.route = toLower(this.route.name);
    }
    this.setRefreshItem();
    this.searchData = debounce(this.searchData, 400);
  },
  beforeDestroy() {
    clearInterval(this.refreshTimer);
  },
  methods: {
    ...mapActions([
      'resetFilters',
      'resetTicketsFilters',
      'setChannel',
      'setExportType',
      'setFilters',
      'setInfoMessage',
    ]),
    expandFilter(filterValue) {
      if (this.currentFilter === filterValue) {
        const index = this.currentFilter;
        this.toolbarItems[index].status = !this.toolbarItems[index].status;
      } else {
        if (this.currentFilter) {
          this.toolbarItems[this.currentFilter].status = false;
        }
        this.toolbarItems[filterValue].status = true;
      }
      this.currentFilter = filterValue;
    },
    expandExportFilter() {
      this.exportFilter = !this.exportFilter;
    },
    expandRefreshFilter() {
      this.refreshFilter = !this.refreshFilter;
    },
    expandRestartFilters() {
      this.restartFilter = !this.restartFilter;
    },
    loadPage(value) {
      if (value.isDateValid) {
        this.closeFilter();
        this.$emit('setFilters', {
          dateFrom: `${value.dateFrom}*${get(value.timeFrom, '_i')}`,
          dateTo: `${value.dateTo}*${get(value.timeTo, '_i')}`,
        });
      }
    },
    closeFilter() {
      if (this.currentFilter) {
        this.toolbarItems[this.currentFilter].status = false;
      }
    },
    closeExportFilter() {
      this.exportFilter = false;
    },
    closeRefreshFilter() {
      this.refreshFilter = false;
    },
    closeRestartFilter() {
      this.restartFilter = false;
    },
    downloadFile(type) {
      this.exportFilter = false;
      this.setExportType(type);
    },
    navItemsVisibility() {
      this.navigationItems = !this.navigationItems;
    },
    resetHeaderFilters() {
      this.restartFilter = false;
      this.resetFilters();
      bus.$emit('restartFilters');
    },
    getPages() {
      bus.$emit('getPagination', {
        page: 1,
        pageSize: 25,
      });
    },
    searchFilters(values) {
      this.toolbarItems[values.filter].search = values.search;
      this.searchFilter = values;
    },
    setToolbarItem(values) {
      this.toolbarItems[values.filter].selected = values.selected;
      this.setFilters({
        filter: values.filter,
        selected: values.selected.length ? `${values.selected}` : [],
      });
      this.getPages();
    },
    setChannelItem(channel) {
      this.resetTicketsFilters();
      this.currentChannel = channel;
      this.setChannel(channel);
      this.getPages();
    },
    setRefreshItem(interval) {
      this.refreshFilter = false;
      clearInterval(this.refreshTimer);
      if (interval) {
        this.refreshTimer = setInterval(() => { this.$emit('load'); }, interval);
      }
    },
    searchData() {
      this.$emit('search', this.searchItems);
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/general/_header.scss";
.navigation-bar {
  height: 48px;
  background-color: #d3dadd;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .menu {
    display: none;
  }
}

.navigation-bar :nth-child(n+2) a {
  margin-left: 20px;
}

.navigation-items {
  display: flex;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
  a {
    width: 44px;
    height: 14px;
    font-size: 12px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: #6b7585;
    &:hover {
      color: #009aff;
    }
  }
  .n-i {
    font-size: 10px;
  }
}

.navigation-filters {
  display: flex;
  padding-right: 10px;
  .search-text {
    margin: 0;
    height: 32px;
    margin-right: 10px;
  }
}

.refresh, .restart, .export {
  background-color: #929cac;
  height: 32px;
  width: 32px;
  text-align: center;
  padding-top: 8px;
  border-radius: 2px;
  .n-i {
    font-size: 16px;
    color:#ffffff;
  }
}

.export {
  margin-right: 5px;
}

.export-container {
  display: flex;
  flex-direction: column;
  position: absolute;
  padding: 12px 10px;
  width: 165px;
  right: 0;
  z-index: 10;
  background: #ffffff;
  border: 1px solid #d3dadd;
  margin-top: 33px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  .export-item {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 30px;
    background: #929cac;
    margin-top: 10px;
    color:#ffffff;
    &:hover {
      background: #6b7585;
    }
    &:active {
      background: #009aff;
    }
  }
  .export-text {
    display: flex;
    justify-content: center;
    font-size: 16px;
    color: #6b7585;
  }
}

.filterDisabled {
  pointer-events: none;
  opacity: 0.4;
}

.restart {
  margin-left: 5px;
}

.refresh-container {
  position: absolute;
  background-color: #fff;
  border: 1px solid #b0b8c1;
  box-shadow: 0 1px 1px 0 #dfdfdf;
  padding: 10px 0 10px 10px;
  margin-top: 33px;
  position: absolute;
  right: 0;
  z-index: 10;
  width: 160px;
  .refresh-text {
    > span {
    color: #6b7585;
    font-size: 16px;
    }
  }
  .filter-radio {
    label {
      font-size: 14px;
    }
  }
  .single-filter-container {
    position: relative;
    margin: 0;
  }
  .radio-button-container {
    padding: 0;
    background-color: #ffffff;
    margin-top: 10px;
  }
}

.restart-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: absolute;
  width: 120px;
  margin-top: 33px;
  padding-bottom: 10px;
  right: 0;
  z-index: 10;
  background: #ffffff;
  border: 1px solid #d3dadd;
  user-select: none;
  div {
    &:first-child {
      color: #6b7585;
    }
    &:nth-child(2) {
      button {
        color: #ffffff;
        font-size: 14px;
        background-color: #929cac;
        display: block;
        height: auto;
        width: 90px;
        margin-top: 10px;
        &:focus {
          outline:0;
        }
        &:active {
          background-color: #009aff;
        }
      }
    }
  }
}

.text-color {
  font-weight: bold !important;
}

.toolbar-filter-data {
  color: $toolbarPanelBlueGrey;
  font-size: 12px;
}

.date-range-card {
  padding: 10px 10px 0px 20px;
  z-index: 10;
}

@media only screen and (max-width: 750px) {
  .navigation-bar {
    .menu {
      display: block;
      padding-left: 10px;
    }
  }
  .navigation-bar :nth-child(n+2) a {
    margin-left: 0;
  }
  .date-range-container, .single-filter-container {
    margin: 0;
  }
  .navigation-items {
    flex-direction: column;
    align-items: flex-start;
    position: absolute;
    background: #d3dadd;
    margin-top: 85px;
    padding: 10px;
    z-index: 10;
  }
}
</style>
